import React from 'react';
import facebook from '../public/img/facebook.svg';
import Image from 'next/image';

const FacebookLink = () => {
  return (
    <div>
      <a
        href="https://www.facebook.com/primabrands.it"
        target="_blank"
        rel="noreferrer"
        className="flex items-center text-white"
      >
        <Image src={facebook} alt="facebook logo" className="flex w-3" />
        <p className="font-normal text-sm mx-2">Facebook</p>
      </a>
    </div>
  );
};

export default FacebookLink;
